<template>
	<div class="book-c-review">
		<div class="bookcr-box">
			<div class="bcr-head">
				<label>订单信息确认</label>
			</div>
			<div class="bcr-content">
				<div class="bcrc-text">
					<label>酒店名称：</label>
					<span>{{bookInfo.details.HotelName}}</span>
				</div>
				<div class="bcrc-text">
					<label>房型名称：</label>
					<span>{{bookInfo.RoomName}}</span>
				</div>
				<div class="bcrc-text">
					<label>产品名称：</label>
					<span>{{bookInfo.RPName}}</span>
				</div>
				<div class="bcrc-text">
					<label>入离日期：</label>
					<span class="active">{{bookInfo.CheckIn}} 至 {{bookInfo.CheckOut}} </span>
				</div>
				<div class="bcrc-text">
					<label>房间数量：</label>
					<span>{{bookInfo.RoomCount}} 间</span>
				</div>
				<div class="bcrc-text" v-if="info.ChimelongCode">
					<label>马戏场次：</label>
					<span>{{info.ChimelongCode.Date+' | '+info.ChimelongCode.SeasonItemText}}</span>
				</div>
				<div class="bcrc-text">
					<label>订单总额：</label>
					<span v-if="bookInfo.MealsAmount">{{Currency}} {{bookInfo.AdultPrice+bookInfo.MealsAmount}}</span>
					<span v-else>{{Currency}} {{bookInfo.AdultPrice}}</span>
				</div>
				<div class="bcrc-text">
					<label>住客国籍：</label>
					<span>{{bookInfo.Country.CNName}}</span>
				</div>
				<div class="bcrc-text">
					<label>住客姓名：</label>
					<div class="bcrc-guest">
						<span v-for="(item,index) in info.Guests">{{item.LastName}} {{item.FirstName}}</span>
					</div>
				</div>
				<div class="bcrc-text">
					<label>特殊要求：</label>
					<span>{{info.SpecialRequest}}</span>
				</div>
				<div class="bcrc-text">
					<label>取消规则：</label>
					<span>{{bookInfo.CancelPolicy}}</span>
				</div>
			</div>

			<div class="bcr-commit">
				<!-- <span class="bcr-ok" @click="ok">确认提交</span>
				<span class="bcr-cancel" @click="cancel">返回</span> -->
				<input type="button" value="确认提交" :class="!okDisabled?'bcr-ok':'bcr-ok active'" @click="ok" :disabled="okDisabled">
				<input class="bcr-cancel" value="返回" @click="cancel">
				
			</div>
		</div>
	</div>
	
</template>
<script>
	export default{
		props:{
			info: {
                type: Object,
                default: function(){
                	return{}
                }
            },
			bookInfo: {
                type: Object,
                default: function(){
                	return{}
                }
            }
		},
		data(){
			return{
				Currency: this.dao.get('userInfo').Currency,
				okDisabled:false
			}
		},
		methods:{
			ok(){
				this.okDisabled=true
				this.$emit('ok')
			},
			cancel(){
				this.$emit('cancel');
			},

		},
		mounted() {
			var that = this
			that.$nextTick(() => {
				if(localStorage.getItem('lang')=='t'){
          that.$zh_tran(localStorage.getItem('lang'))
        }    
			})
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/bookReview/bookReview.vue